import { defineMessages } from "react-intl";

const messages = defineMessages({
    browse: {
        id: "menu.browse",
    },
    filters: {
        id: "filters.title",
    },
    searchTitleLabel: {
        id: "filter.filterTitleLabel",
    },
    deleteFilters: {
        id: "filters.delete",
    },
    noResults: {
        id: "browse.noResults",
    },
    totalDocs: {
        id: "browse.totalDocs",
    },
    sortType: {
        id: "browse.sortType",
    },
    popularity: {
        id: "browse.popularity",
    },
    newsFirst: {
        id: "browse.newsFirst",
    },
    seoDescription: {
        id: "browse.seo.description",
    },
});

export default messages;
